import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from "../models/user.model";
import { BehaviorSubject, observable, Observable } from "rxjs";
import { HHSGSharedNotificationDetails } from "../models/notification-details.model";
import { HhsgSharedConfigService } from "./config.service";
import { HhsgSharedHttpService } from "./http.service";
import { HhsgSharedNotificationModel } from "../models/notification.model";
import { HhsgSharedEmailMessage } from "../models/email-message.model";


@Injectable({
    providedIn: 'root'
})

export class HhsgSharedNotificationService {
    private notificationCount = new BehaviorSubject<number>(null);
    notificationCount$ : Observable<number> = this.notificationCount.asObservable();
    private readonly _apiServer: string;
    private applicationId = new BehaviorSubject<number>(null);
    applicationId$ : Observable<number>  = this.applicationId.asObservable();
    public confirmSaving: boolean = false;

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._apiServer = _configService.appSettings.stsServer;
    }

    async getNotificationDetails(userId:number,applicationAbbreviation:string,inculdeReadNotification:boolean) : Promise<HHSGSharedNotificationDetails[]>{
        let queryParams = new HttpParams()
        .append("userId",userId.toString())
        .append("applicationAbbreviation",applicationAbbreviation)
        .append("inculdeReadNotification",inculdeReadNotification);
        return await this._httpService.doApiGetRequestWithParamsAsync<HHSGSharedNotificationDetails[]>(this._apiServer,'Notifications','GetNotificationDetails',queryParams);
    }

    async updateNotificationDetails(notificationModel: HHSGSharedNotificationDetails[]): Promise<boolean>{
		  return await this._httpService.doPostRequestAsync(this._apiServer,'Notifications','UpdateIsReadNotifications',notificationModel);
	  }

    deleteNotificationDetails(notificationModel: HHSGSharedNotificationDetails[]): Promise<boolean>{
		  return this._httpService.doPostRequestAsync(this._apiServer,'Notifications','DeleteNotifications',notificationModel);
	  } 


    announceNotificationCount(notificationCount : number) : void{
        this.notificationCount.next(notificationCount);
    }

    getNotificationCount(userId : number, applicationAbbreviation : string): Observable<number>{
        if(!(userId==0 || userId===undefined)){
            let queryParams = new HttpParams().append("userId", userId).append("applicationAbbreviation", applicationAbbreviation);
            return this._httpService.doGetRequestWithParams<number>(this._apiServer,'Notifications','GetNotificationCount', queryParams);
        }
    }

    async SaveNotification(notificationModel: HhsgSharedNotificationModel): Promise<HhsgSharedNotificationModel> {
		return this._httpService.doPostRequestAsync(this._apiServer,'Notifications', 'SaveNotification', notificationModel);
	}

  async getNotificationTemplateByApplicationAbbreviation(applicationAbbreviation : string) : Promise<HhsgSharedEmailMessage>{
    let queryParams = new HttpParams().append("applicationAbbreviation", applicationAbbreviation);
    return await this._httpService.doApiGetRequestWithParamsAsync<HhsgSharedEmailMessage>(this._apiServer,'Notifications','GetNotificationTemplateByApplicationAbbreviation',queryParams);
  }

}
